import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Actionadd from "./inspectionPopup";
let textInput = React.createRef();


   

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 0,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {

    const [state, setState] = useState({
        Schedule:[{
        id:1,
        peoplename:"Khurram Naushad",
        type:"owner"
        
       },
      { 
        id:2,
        peoplename:"Khurram Naushad",
        type:"owner"
       
    
      },
      {  
        id:3,
        peoplename:"Khurram Naushad",
        type:"owner"
        
        
      },
      {  
        id:4,
        peoplename:"Khurram Naushad",
        type:"owner"
         
        
      },
      {  
        id:5,
        peoplename:"Khurram Naushad",
        type:"owner"
         
        
      },
      { 
        id:6,
        peoplename:"Khurram Naushad",
        type:"owner"
       
        
      }
    ],
    
    filter_arr: null
    
    
    })


    const list = state.Schedule.map((value,index)=>{

        return(
            <React.Fragment>
        <div className="col s8 inspection-name" >{value.peoplename}</div>
        <div className="col s4 inspection-name">{value.type}</div>
        </React.Fragment>
        )


    })
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const ModalOpen = () => {
  
    setIsModalOpen(true)

  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  const handleAddresponseClick = (e) => 
  {
    const data = state.Schedule.slice(0);
    let newresponse ={name:textInput.current.value};
    let sharedpeople= newresponse.name;
    data.push({
        peoplename:sharedpeople,
        type:"owner"
       });
       setState({Schedule:data })
       textInput.current.value ="";
      //let newresponse ={name:textInput.current.value};
      //response.data.responseSet.push(newresponse);
      //let Response = this.state.ResponseDetail[0];
      //this.setState({Response:response})
  }
  return (
      
    <div className={classes.root}>
      <AppBar position="static" className="Customtabbar">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Details" {...a11yProps(0)} />
          <Tab label="Sharing" {...a11yProps(1)} />
          <Tab label="Action" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <div className="">
          <table class="details-table">
            <tr>
              <td className="custom-spacing">Template</td>
              <td className="table-truncate">
                <b>Workplace Reopening Checklist for</b>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Status</td>
              <td style={{ color: "red" }}>
                <b>Incomplete </b>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Score</td>
              <td>
                <b>0%</b>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Items Completed</td>
              <td>
                <div>
                  <b>0 / 36</b>
                </div>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Organisation</td>
              <td>
                <div>
                  <b>Finesols Team</b>
                </div>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Owner</td>
              <td>
                <div>
                  <b>Khurram Naushad Khan</b>
                </div>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Author</td>
              <td>
                <div>
                  <b>Khurram Naushad Khan</b>
                </div>
              </td>
            </tr>
            <tr>
              <td className="custom-spacing">Last modified by</td>
              <td>
                <div>
                  <b>Khurram Naushad Khan</b>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div className="row center-align">
          <button
            class="btn waves-effect waves-light"
            style={{ marginTop: "30px", marginRight: "1em" }}
          >
            View Report
          </button>
          <button
            class="btn waves-effect waves-light"
            style={{ marginTop: "30px", marginRight: "1em" }}
          >
            Export Report
          </button>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <div className="">
          <div className="col s12"><span>Add People</span></div>
          <div className="col s12">
                <div className="row">
                    <div className="col s8"><input ref={textInput} type="text" /></div>
                    <div className="col s4">
                        <button class="btn waves-effect waves-light"  onClick={(e)=>handleAddresponseClick(e)} style={{ marginTop: "5px", marginRight: "1em" }}>create</button>
                    </div>

                </div>
              </div>
              <div className="col s12"><span>Current Shares</span></div>
              <div className="col s12" style={{height:'400px'}}>

                        <div className="col s12 ">
                               <div className="row custom-row">
                                    {list}
                               </div>
                        </div>


              </div>


            </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className="col s12">

        </div>
        
        <div className="row center-align">
          <div className="container">
              <img src="./images/noaction.svg" style={{width:'50%'}} />
              <br></br>
              <div className="center-align">No Action found</div>
              <div className="center-align">Click Add Action to add an action to this inspection.</div>

          </div>

        <hr></hr>
          <button  onClick={() => ModalOpen() }
            class="btn waves-effect waves-light"
            style={{ marginTop: "30px", marginRight: "1em" }}
          >
           Add Action
          </button>
         
        </div>
      </TabPanel>
      {
        isModalOpen &&  <Actionadd onClose={() => setIsModalOpen(false)}/>
       }
    </div>
  );
}
